module.exports = __webpack_public_path__ + "img/logo.be88f4f7.png";